import type {ReactElement} from 'react';
import React from 'react';
import {EdgeType} from '@PosterWhiteboard/classes/item-effects.class';
import {PosterEditingBaseDropdownOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-dropdown-option';
import type {DropdownItemStorage} from '@Components/contextual-menu/components/contextual-menu-dropdown-option';
import {BaseCurveEdgeEffectThicknessOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-curve-edge-effect-thickness-option';
import {BaseGradientEdgeEffectThicknessOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-gradient-edge-effect-thickness-option';

interface BaseItemEdgeEffectsOptionProps {
  edgeType: EdgeType;
  edgeThickness: number;
  showCurvedEffect?: boolean;

  applyEffect(valueToApply: EdgeType): void;

  onChangeThickness(value: number, undoable?: boolean): void;
}

export function BaseItemEdgeEffectsOption({showCurvedEffect = true, ...props}: BaseItemEdgeEffectsOptionProps): ReactElement<any> {
  const showSubOption = (): boolean => {
    // SelfCodeReviewAhmed: need to figure out the reason for a type mismatch here
    return Number(props.edgeType) === Number(EdgeType.GRADIENT);
  };

  const onUpdateThickness = (edgeThickness: number, undoable = true): void => {
    props.onChangeThickness(edgeThickness, undoable);
  };

  const showSubOptionForGradient = (): ReactElement<any> => {
    return <BaseGradientEdgeEffectThicknessOption edgeThickness={props.edgeThickness} onUpdateThickness={onUpdateThickness} />;
  };

  const getSubOptions = (): ReactElement<any> | null => {
    if (!showSubOption()) {
      return null;
    }

    if (Number(props.edgeType) === Number(EdgeType.GRADIENT)) {
      return showSubOptionForGradient();
    }

    return null;
  };

  const applyEffect = (valueToApply: EdgeType): void => {
    props.applyEffect(valueToApply);
  };

  const getOptions = (): Array<DropdownItemStorage> => {
    return [
      {text: window.i18next.t('pmwjs_none'), id: EdgeType.NONE},
      {text: window.i18next.t('pmwjs_oval'), id: EdgeType.OVAL},
      {text: window.i18next.t('pmwjs_rectangle'), id: EdgeType.RECTANGLE},
      {text: window.i18next.t('pmwjs_background_gradient'), id: EdgeType.GRADIENT},
      {text: window.i18next.t('pmwjs_scratched'), id: EdgeType.SCRATCHED},
      {text: window.i18next.t('pmwjs_torn_paper'), id: EdgeType.TORN_PAPER},
      {text: window.i18next.t('pmwjs_circular'), id: EdgeType.CIRCULAR},
      {text: window.i18next.t('pmwjs_heart'), id: EdgeType.HEART},
    ];
  };

  return (
    <PosterEditingBaseDropdownOption
      id="item-edge-effects-option"
      label={window.i18next.t('pmwjs_edge_effects')}
      onClick={applyEffect}
      dropdownItems={getOptions()}
      selectedItemId={props.edgeType === EdgeType.CURVED ? Number(EdgeType.NONE) : Number(props.edgeType)}
    >
      {getSubOptions()}
    </PosterEditingBaseDropdownOption>
  );
}
